// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../images/vaped4u-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #F2F0EB;
  color: white;
}

.Main_label__eVyFU {
  /* width: 188px;
  height: 143px; */
  float: left;
  /* background-size: 200px 148px; */
  cursor: pointer;
  padding-left: 1%;
  padding-right: 1%;
  padding-top: 1%;
  padding-bottom: 1%;
}

.Main_labelArea__OMcJs {
  margin: auto;
  width: 756px;
  display: block;
  overflow: auto;
  height: 100%;
  background-color: white;
  box-shadow: 0px 0px 10px 4px rgba(101,196,224, 0.2);
  justify-content: space-evenly;
}

.Main_price__nDLFf {
  font-weight: bold;
  font-size: small;
  color: black;
  width: 90%;
  margin: auto;
  text-shadow: rgb(255, 255, 255) 1px 0px 0px,
    rgb(255, 255, 255) 0.540302px 0.841471px 0px,
    rgb(255, 255, 255) -0.416147px 0.909297px 0px,
    rgb(255, 255, 255) -0.989992px 0.14112px 0px,
    rgb(255, 255, 255) -0.653644px -0.756802px 0px,
    rgb(255, 255, 255) 0.283662px -0.958924px 0px,
    rgb(255, 255, 255) 0.96017px -0.279415px 0px;
  background-color: white;
  border-radius: 0 0 15px 15px;
  border-bottom: 2px solid #FE5A9E;
  border-top: 1px solid #FE5A9E;
  border-left: 2px solid #FE5A9E;
  border-right: 2px solid #FE5A9E;
}

.Main_name__jsn5t {
  font-weight: bold;
  font-size: small;
  color: #333;
  /* height: 65%; */
  width: 90%;
  margin: auto;
  text-shadow: rgb(255, 255, 255) 1px 0px 0px,
    rgb(255, 255, 255) 0.540302px 0.841471px 0px,
    rgb(255, 255, 255) -0.416147px 0.909297px 0px,
    rgb(255, 255, 255) -0.989992px 0.14112px 0px,
    rgb(255, 255, 255) -0.653644px -0.756802px 0px,
    rgb(255, 255, 255) 0.283662px -0.958924px 0px,
    rgb(255, 255, 255) 0.96017px -0.279415px 0px;
  background-color: white;
  border-radius: 15px 15px 0 0;
  border-top: 2px solid #FE5A9E;
  border-left: 2px solid #FE5A9E;
  border-right: 2px solid #FE5A9E;
}


/* \$sdPink: #FE5A9E;
\$sdOrange: #FDA17F;
\$sdYellow: #78c7cc; */
.Main_searchBar__Rih36 {
  border: 3px ridge #FE5A9E;
  background-color: #78c7cc;
  font-weight: bold;
  color: black;
  box-shadow: 0px 0px 10px 4px rgba(101,196,224, 0.2);
}

.Main_rt__AV0EK {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 70px;
  height: 25px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.Main_rta__EA4sh {
  margin-top: 1px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.Main_shown__1nclM {
  height: 30px;
}

input {
  width: 300px;
}

.Main_shelfedge__gWRzh {
text-align: center;

}

.Main_labelCount__CyQ0g{
border: 1px solid #FE5A9E;
color: black;
background-color: #fff;
}

@media screen and (min-width: 300px) and (max-width: 1200px) {
  .Main_labelArea__OMcJs {
    width: 100%;
    margin-left:6%;
  }
  input {
    width: 250px;
  }
  .Main_labelCount__CyQ0g{
    width:90%;
    margin-left:10%;
  }
  .Main_searchBar__Rih36{
    width:90%;
    margin-left:10%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StoreZone/V4ULabels/styles/Main.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;kBACgB;EAChB,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,mDAAmD;EACnD,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ;;;;;;gDAM8C;EAC9C,uBAAuB;EACvB,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ;;;;;;gDAM8C;EAC9C,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;;AAGA;;qBAEqB;AACrB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE,yDAA4D;EAC5D,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;AACA,kBAAkB;;AAElB;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,sBAAsB;AACtB;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":["body {\n  background-color: #F2F0EB;\n  color: white;\n}\n\n.label {\n  /* width: 188px;\n  height: 143px; */\n  float: left;\n  /* background-size: 200px 148px; */\n  cursor: pointer;\n  padding-left: 1%;\n  padding-right: 1%;\n  padding-top: 1%;\n  padding-bottom: 1%;\n}\n\n.labelArea {\n  margin: auto;\n  width: 756px;\n  display: block;\n  overflow: auto;\n  height: 100%;\n  background-color: white;\n  box-shadow: 0px 0px 10px 4px rgba(101,196,224, 0.2);\n  justify-content: space-evenly;\n}\n\n.price {\n  font-weight: bold;\n  font-size: small;\n  color: black;\n  width: 90%;\n  margin: auto;\n  text-shadow: rgb(255, 255, 255) 1px 0px 0px,\n    rgb(255, 255, 255) 0.540302px 0.841471px 0px,\n    rgb(255, 255, 255) -0.416147px 0.909297px 0px,\n    rgb(255, 255, 255) -0.989992px 0.14112px 0px,\n    rgb(255, 255, 255) -0.653644px -0.756802px 0px,\n    rgb(255, 255, 255) 0.283662px -0.958924px 0px,\n    rgb(255, 255, 255) 0.96017px -0.279415px 0px;\n  background-color: white;\n  border-radius: 0 0 15px 15px;\n  border-bottom: 2px solid #FE5A9E;\n  border-top: 1px solid #FE5A9E;\n  border-left: 2px solid #FE5A9E;\n  border-right: 2px solid #FE5A9E;\n}\n\n.name {\n  font-weight: bold;\n  font-size: small;\n  color: #333;\n  /* height: 65%; */\n  width: 90%;\n  margin: auto;\n  text-shadow: rgb(255, 255, 255) 1px 0px 0px,\n    rgb(255, 255, 255) 0.540302px 0.841471px 0px,\n    rgb(255, 255, 255) -0.416147px 0.909297px 0px,\n    rgb(255, 255, 255) -0.989992px 0.14112px 0px,\n    rgb(255, 255, 255) -0.653644px -0.756802px 0px,\n    rgb(255, 255, 255) 0.283662px -0.958924px 0px,\n    rgb(255, 255, 255) 0.96017px -0.279415px 0px;\n  background-color: white;\n  border-radius: 15px 15px 0 0;\n  border-top: 2px solid #FE5A9E;\n  border-left: 2px solid #FE5A9E;\n  border-right: 2px solid #FE5A9E;\n}\n\n\n/* $sdPink: #FE5A9E;\n$sdOrange: #FDA17F;\n$sdYellow: #78c7cc; */\n.searchBar {\n  border: 3px ridge #FE5A9E;\n  background-color: #78c7cc;\n  font-weight: bold;\n  color: black;\n  box-shadow: 0px 0px 10px 4px rgba(101,196,224, 0.2);\n}\n\n.rt {\n  background-image: url(\"../../../../images/vaped4u-logo.png\");\n  width: 70px;\n  height: 25px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n}\n\n.rta {\n  margin-top: 1px;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n.shown {\n  height: 30px;\n}\n\ninput {\n  width: 300px;\n}\n\n.shelfedge {\ntext-align: center;\n\n}\n\n.labelCount{\nborder: 1px solid #FE5A9E;\ncolor: black;\nbackground-color: #fff;\n}\n\n@media screen and (min-width: 300px) and (max-width: 1200px) {\n  .labelArea {\n    width: 100%;\n    margin-left:6%;\n  }\n  input {\n    width: 250px;\n  }\n  .labelCount{\n    width:90%;\n    margin-left:10%;\n  }\n  .searchBar{\n    width:90%;\n    margin-left:10%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `Main_label__eVyFU`,
	"labelArea": `Main_labelArea__OMcJs`,
	"price": `Main_price__nDLFf`,
	"name": `Main_name__jsn5t`,
	"searchBar": `Main_searchBar__Rih36`,
	"rt": `Main_rt__AV0EK`,
	"rta": `Main_rta__EA4sh`,
	"shown": `Main_shown__1nclM`,
	"shelfedge": `Main_shelfedge__gWRzh`,
	"labelCount": `Main_labelCount__CyQ0g`
};
export default ___CSS_LOADER_EXPORT___;
